export const AlbumEidtingFaq = [
  {
    question: "What is album design?",
    answer:
      "Album design is the process of creatively arranging your photos into a beautiful, print-ready layout—perfect for weddings, pre-weddings, engagements, or family sessions. We turn your photos into storytelling spreads that capture your memories.",
  },
  {
    question: "What types of albums do you design?",
    answer:
      "We design: Wedding Albums, Pre-Wedding Albums, Baby and Family Albums, Traditional and Flush Mount Albums.",
  },
  {
    question: "Can I choose a specific design style or theme?",
    answer:
      "Absolutely! We offer a range of styles such as classic, modern, minimal, cinematic, or traditional Indian layouts. You can also send reference samples or request a custom look.",
  },
  {
    question: "Can I review and request changes to the design?",
    answer:
      "Yes, we provide a preview link or PDF proof for you to review. You can request revisions before the final files are prepared for print.",
  },
  {
    question: "How many photos do I need to send?",
    answer:
      "Typically, we suggest: 30–40 photos for a 10-page album, and 80–120 photos for a 20-page album. We’ll help curate and arrange the best selections for a balanced story flow.",
  },
  {
    question: "What is the turnaround time?",
    answer:
      "Our standard delivery time is 3–5 business days for a 20-page album. Express service is available upon request. Final delivery depends on the complexity and number of changes.",
  },
  {
    question: "In what format will I receive the files?",
    answer:
      "You’ll receive high-resolution JPEGs (print-ready), an optional PDF preview for review, and we can also deliver PSD layered files if requested.",
  },
];
